export const URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_DEV_URL : process.env.REACT_APP_DEV_URL
export const HOMEURL = process.env.NODE_ENV === 'production' ? process.env.PUBLIC_URL : process.env.PUBLIC_URL
